// Order Pipeline Constants and Configuration
import { Circle, Play, Clock, CheckCircle2, Calendar as CalendarIcon, CalendarRange, LayoutGrid } from 'lucide-react';

export const ORDER_STATUSES = [
  { value: 'not_started', label: 'Not Started', color: 'bg-red-100 text-red-700', icon: Circle },
  { value: 'in_progress', label: 'In Progress', color: 'bg-amber-100 text-amber-700', icon: Play },
  { value: 'locked', label: 'Ready', color: 'bg-blue-100 text-blue-700', icon: Clock },
  { value: 'dispatched', label: 'Dispatched', color: 'bg-emerald-100 text-emerald-700', icon: CheckCircle2 },
];

export const VIEW_MODES = [
  { value: 'day', label: 'Day', icon: CalendarIcon },
  { value: 'week', label: 'Week', icon: CalendarRange },
  { value: 'month', label: 'Month', icon: LayoutGrid },
];

export const STATUS_ORDER = ['not_started', 'in_progress', 'locked', 'dispatched'];

export const getStatusInfo = (status) => {
  if (status === 'draft') return ORDER_STATUSES[0]; // Map draft to not_started
  return ORDER_STATUSES.find(s => s.value === status) || ORDER_STATUSES[0];
};

export const getStatusIndex = (status) => {
  return STATUS_ORDER.indexOf(status);
};

export const isStatusBackward = (fromStatus, toStatus) => {
  return getStatusIndex(toStatus) < getStatusIndex(fromStatus);
};

// Batch validation configuration
export const VALIDATION_CONFIG = {
  units: {
    softWarningLower: 0.05, // 5% lower
    softWarningHigher: 0.05, // 5% higher
  },
  weight: {
    softWarningLower: 0.05, // 5% lower
    softWarningHigher: 0.20, // 20% higher
  },
  cases: {
    softWarningLower: 0.20, // 20% lower
    softWarningHigher: 0.20, // 20% higher
  }
};
